export default {
  // Extra small (<576px)
  xs: {
    min: 0,
    max: 575
  },
  // Small ≥ 576px
  sm: {
    min: 576,
    max: 767
  },
  // Medium ≥ 768px
  md: {
    min: 768,
    max: 991
  },
  // Large ≥ 992px
  lg: {
    min: 992,
    max: 1199
  },
  // Extra large ≥ 1200px
  xl: {
    min: 1200
  }
}
